/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStatusDaeEnum } from './APIStatusDaeEnum';
import {
    APIStatusDaeEnumFromJSON,
    APIStatusDaeEnumFromJSONTyped,
    APIStatusDaeEnumToJSON,
} from './APIStatusDaeEnum';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APICustomerOrderRequest
 */
export interface APICustomerOrderRequest {
    /**
     * 
     * @type {Date}
     * @memberof APICustomerOrderRequest
     */
    orderDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APICustomerOrderRequest
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof APICustomerOrderRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof APICustomerOrderRequest
     */
    wishDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof APICustomerOrderRequest
     */
    article: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerOrderRequest
     */
    customer: string;
    /**
     * 
     * @type {number}
     * @memberof APICustomerOrderRequest
     */
    amount: number;
    /**
     * 
     * @type {APIStatusDaeEnum}
     * @memberof APICustomerOrderRequest
     */
    status?: APIStatusDaeEnum;
    /**
     * 
     * @type {string}
     * @memberof APICustomerOrderRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerOrderRequest
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerOrderRequest
     */
    customerReference?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APICustomerOrderRequest
     */
    planning?: APIPlanningEnum | null;
    /**
     * 
     * @type {number}
     * @memberof APICustomerOrderRequest
     */
    priority?: number | null;
}



/**
 * Check if a given object implements the APICustomerOrderRequest interface.
 */
export function instanceOfAPICustomerOrderRequest(value: object): value is APICustomerOrderRequest {
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function APICustomerOrderRequestFromJSON(json: any): APICustomerOrderRequest {
    return APICustomerOrderRequestFromJSONTyped(json, false);
}

export function APICustomerOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderDate': json['order_date'] == null ? undefined : (new Date(json['order_date'])),
        'startDate': (new Date(json['start_date'])),
        'dueDate': json['due_date'] == null ? undefined : (new Date(json['due_date'])),
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'article': json['article'],
        'customer': json['customer'],
        'amount': json['amount'],
        'status': json['status'] == null ? undefined : APIStatusDaeEnumFromJSON(json['status']),
        'description': json['description'] == null ? undefined : json['description'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'customerReference': json['customer_reference'] == null ? undefined : json['customer_reference'],
        'planning': json['planning'] == null ? undefined : APIPlanningEnumFromJSON(json['planning']),
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function APICustomerOrderRequestToJSON(value?: APICustomerOrderRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'order_date': value['orderDate'] == null ? undefined : ((value['orderDate']).toISOString()),
        'start_date': ((value['startDate']).toISOString()),
        'due_date': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate']).toISOString()),
        'article': value['article'],
        'customer': value['customer'],
        'amount': value['amount'],
        'status': APIStatusDaeEnumToJSON(value['status']),
        'description': value['description'],
        'comment': value['comment'],
        'customer_reference': value['customerReference'],
        'planning': APIPlanningEnumToJSON(value['planning']),
        'priority': value['priority'],
    };
}

